import { Box, List, ListItem, ListItemIcon, ListItemText, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { Square } from "@mui/icons-material";
import { IObjectMap } from "../../../services/data-file-import-data-service/Models";
import { getObjectTypeName } from "../../../common/utilities/GetObjectTypeName";
import { useTranslation } from "react-i18next";

export type DataFileImportObjectsCardProps = {
    items: IObjectMap[],
    sx?: SxProps<Theme>; 
};

export function DataFileImportObjectsCard({
    items,
    sx
}: DataFileImportObjectsCardProps) {

    const theme = useTheme();
    const { t } = useTranslation();

    const objectList = items.sort((a, b) => (a.identifier ?? '').localeCompare(b.identifier ?? ''));


    function renderItem(item: IObjectMap) {
        return (


            <Typography variant='body2'>
                {
                t('dataFileImport.objectMapItem', {
                    identifier: item.identifier,
                    objectType: getObjectTypeName(item.mappedObject.objectType, false, true),
                    name: item.mappedObject.displayText
                })
                }

            </Typography>

            

        )
    }

    return (
        <Box sx={{
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 6,
            marginRight: 1,
            padding: 1,
            paddingBottom: 0,
            ...sx
        }}>
            <Typography variant="body2"
                sx={{
                    color: theme.palette.grey[600],
                }}>
                {t('dataFileImport.objects')}
            </Typography>
            <List sx={{
                        paddingTop: 0,
                        overflowX: "hidden",
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto'        
                    }}>

                        {objectList.map((o, index) =>


                        <ListItem key={index} disablePadding >

                        <ListItemIcon sx={{fontSize: ".4rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                            <Square fontSize="inherit"/>
                        </ListItemIcon>

                        <ListItemText 
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            primary={
                                // renderProperty('Identifier:', o.identifier)
                                renderItem(o)
                            } 

                            slotProps={{
                                primary: {
                                    component: 'div',
                                    sx: {
                                        fontSize: '.9rem',
                                        display: 'flex',
                                        color: theme.palette.grey[600]
                                    }
                                }
                            }}
                        />

                        </ListItem>  


                        )}                                      
                    </List>
        </Box>
    );
}
